import React from "react";
import Button from "../ui/Button";
import Container from "../ui/Container";
import { BRAND } from "../../lib/config";


export default function SupportCTA() {
    return (
        <section className="bg-[#070A0F] pb-24 pt-10">
            <Container>
                <div className="mx-auto max-w-3xl text-center">
                    <h2 className="text-balance text-3xl font-semibold text-white sm:text-4xl">
                        Still stuck? We will stay with it<span className="text-cyan-300">.</span>
                    </h2>
                    <p className="mt-4 text-base text-white/70">
                        We keep working your request until it is resolved or escalated. You will always know
                        the next step and the owner.
                    </p>
                    <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <Button href="mailto:contact@xahosting.co">Open a ticket</Button>
                        <Button variant="secondary" href={BRAND.statusUrl}>
                            Track incidents
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    )
}